module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_tanzania-8da9a0ed.png";